(function ($) {
  /**
   * Shopify Cart general functionality.
   */
  window.CartUtil = {
    data: [],
    ini: 0,
    total: 0,
    action: 'add',

    reset: function () {
      (this.ini = 0), (this.data = []);
    },
    ajaxpost: function (uri, params, callback) {
      $.ajax({
        type: 'POST',
        url: uri,
        dataType: 'json',
        async: false,
        data: params,
        success: function () {
          if (typeof callback === 'function') {
            callback();
          }
        },
        error: function () {},
      });
    },
    ajaxget: function (uri, callback) {
      $.ajax({
        type: 'GET',
        url: uri,
        dataType: 'json',
        async: false,
        success: function (data) {
          if (typeof callback === 'function') {
            callback.call(this, data);
          }
        },
        error: function () {},
      });
    },
    addItem: function (qty, id, properties, callback) {
      var params = { quantity: qty, id: id };
      if (properties != false) {
        params.properties = properties;
      }
      CartUtil.ajaxpost('/cart/add.js', params, callback);
    },
    updateItem: function (qty, id, properties, callback) {
      var params = { updates: { id: qty } };
      if (properties != false) {
        params.properties = properties;
      }
      CartUtil.ajaxpost('/cart/update.js', params, callback);
    },
    updateAttrs: function (attrs, callback) {
      var params = {
        attributes: attrs,
      };
      CartUtil.ajaxpost('/cart/update.js', params, callback);
    },
    updateNote: function (note_txt, callback) {
      var params = {
        note: note_txt,
      };
      CartUtil.ajaxpost('/cart/update.js', params, callback);
    },
    clear: function (callback) {
      CartUtil.ajaxpost('/cart/clear.js', [], callback);
    },
    recursive: function () {
      var actionname = CartUtil.action == 'update' ? 'updateItem' : 'addItem';
      CartUtil[actionname](
        CartUtil.data[CartUtil.ini].qty,
        CartUtil.data[CartUtil.ini].id,
        CartUtil.data[CartUtil.ini].properties,
        function () {
          CartUtil.ini += 1;
          if (CartUtil.ini < CartUtil.total) {
            CartUtil.recursive();
          } else {
            document.location.href = '/cart';
          }
        }
      );
    },
  };
})(jQuery);
